export const isEmbedded = () => {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
};


type ParamsConfig = {isWebview:boolean, isMockData:boolean};

const readWebviewParam = (): ParamsConfig  => {
  const params = {isWebview:false, isMockData:false, lang:"ar"};
  for (const [key, value] of new URLSearchParams(window.location.search)) {
    if (key.toLowerCase() === "iswebview") params.isWebview = value.toLowerCase() === "true";
    if (key.toLowerCase() === "ismockdata") params.isMockData = value.toLowerCase() === "true";
  }
  return params;
};

export const isWebviewParam = () => readWebviewParam().isWebview === true;
export const isMockData = ()=>readWebviewParam().isMockData === true;

const WEBVIEW_SESSION_KEY = "rc.isWebview";

const writeWebviewSession = (value: boolean) => {
  try {
    if (value) sessionStorage.setItem(WEBVIEW_SESSION_KEY, "true");
    else sessionStorage.removeItem(WEBVIEW_SESSION_KEY);
  } catch {

  }
};

const hasWebviewSessionFlag = () => {
  try {
    return sessionStorage.getItem(WEBVIEW_SESSION_KEY) === "true";
  } catch {
    return false;
  }
};

export const clearWebviewSessionFlag = () => {
  try {
    sessionStorage.removeItem(WEBVIEW_SESSION_KEY);
  } catch {
    // ignore — some WebView hosts restrict DOM storage
  }
};



export const isIntegratedSession = () => {
  const param = readWebviewParam();
  if (param !== null) writeWebviewSession(param.isWebview);
  if (param.isWebview === true) return true;
  if (hasWebviewSessionFlag()) return true;
  return isEmbedded();
};
